import { render, staticRenderFns } from "./materialUpload.vue?vue&type=template&id=b77b9ea8&scoped=true&"
import script from "./materialUpload.vue?vue&type=script&lang=js&"
export * from "./materialUpload.vue?vue&type=script&lang=js&"
import style0 from "./materialUpload.vue?vue&type=style&index=0&id=b77b9ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77b9ea8",
  null
  
)

export default component.exports